<div class="page-inner-body portlet light px-5 my-3">
  <div class="portlet-body p-3">
    @if (IsShowProfile) {
      <div class="table-toolbar bg-light  p-4 rounded shadow-sm">
        <div class="row align-items-center">
          <!-- Profile Section -->
          <div class="d-flex align-items-center mb-3">
            <!-- Profile Image -->
            @if (ProfilePicture) {
              <img [src]="ProfilePicture"
                class="rounded-circle me-2 cursor-pointer border border-primary" height="80" width="80" [alt]="'sharedListProducts.profile' | transloco"
                />
            }
            <!-- Shared By and Business Name -->
            <div>
              <a href="javascript:void(0);" class="fs-5 fw-semibold cursor-pointer">{{ SharedBy }}</a>
              <div class="text-muted small">
                @if (BusinessName) {
                  <span class="fs-6">{{ 'sharedListProducts.tradingAs' | transloco: { name: BusinessName } }}</span>
                }
                <span class="fs-6 ms-2">{{ 'sharedListProducts.artworksSeparator' | transloco }}</span>
              </div>
            </div>
          </div>
          <!-- Description Section -->
          <div class="text-muted fst-italic mb-2">
            @if (AboutMe) {
              {{AboutMe}}
            }
            @if (!AboutMe) {
              {{ 'sharedListProducts.exploreMagnificentPieces' | transloco }}
            }
          </div>
          @if (SharedDate) {
            <div class="text-muted">
              <span>{{ 'sharedListProducts.sharedOn' | transloco: { date: (SharedDate | date: 'dd/MM/yyyy HH:mm a') } }}</span>
            </div>
          }
        </div>
      </div>
    }
    <!-- Products Section -->
    @if (!isPortfolioActive) {
      <div class="row  my-4 p-4 shadow-sm rounded">
        @if (Title) {
          <h3 class="pb-2">{{Title}}</h3>
        }
        @if (Description) {
          <p class="border-bottom pb-2">{{Description}}</p>
        }
        @if (sharedProducts.length === 0) {
          <div class="d-flex justify-content-center">
            <span>{{ 'sharedListProducts.noPortfolioProductsFound' | transloco }}</span>
          </div>
        }
        @for (rowData of sharedProducts; track rowData) {
<div class="col-4 mt-3 dsArtistItem" [ngClass]="{
          'col-4': numberOfColumnToShow == 3,
          'col-3': numberOfColumnToShow == 4,
          'col-2':numberOfColumnToShow == 6 || numberOfColumnToShow == 0

        }">
            <div class="card h-auto shadow-sm border-0 custom-product-card position-relative">
              <!-- Added position-relative to the card to contain absolutely positioned elements -->
              <!-- <ng-container
              *ngIf="!rowData.ArtistProduct.IsConsignedProduct && !rowData.ArtistProduct.IsSold; else soldOrConsigned">
              <span class="badge bg-success position-absolute top-0 end-0 my-1 me-1">Available</span>
            </ng-container> -->
            <ng-template #soldOrConsigned>
              <!-- Sold or Consigned Badges -->
              <!-- <span class="badge bg-danger sold position-absolute top-0 end-0 my-1 me-1"
            *ngIf="rowData.ArtistProduct.IsSold">Sold</span>
            <span class="badge bg-warning consigned position-absolute top-0 end-0 my-1 me-1"
            *ngIf="rowData.ArtistProduct.IsConsignedProduct && !rowData.ArtistProduct.IsSold">Consigned</span> -->
          </ng-template>
          @if (isArtist) {
            <div class="card-img-top cursor-pointer" style="overflow: hidden; border-radius: 0.5rem;"
              (click)="showProductDetail(rowData.ArtistProduct ,'artist')">
              <img
                [src]="rowData.ArtistProduct.ProductImgUrl ? rowData.ArtistProduct.ProductImgUrl : 'assets/images/No-Image.png'"
                class="img-fluid" [alt]="'sharedListProducts.productImage' | transloco"
                style="width: 100%; height: auto; object-fit: contain; transition: transform 0.3s;" />
              </div>
              <div class="card-body text-center dsPortfolioLabel">
                <h5 class="text-uppercase fw-bold">
                  <a href="javascript:void(0);" class="text-dark text-decoration-none dsPortfolioDisplayLabel">
                    {{ rowData.ArtistProduct.Name }}
                  </a>
                </h5>
                <!-- <div class="d-flex justify-content-center align-items-center">
                <span class="fw-semibold">Price:</span>
                <span class="text-success ms-1">
                  {{ rowData.ArtistProduct.ArtistRevenue | currency: currencyCode : 'symbol' : '1.2-2' }}
                </span>
              </div> -->
            </div>
          }
          @if (isGallery) {
            <div class="card-img-top cursor-pointer" style="overflow: hidden; border-radius: 0.5rem;"
              (click)="showProductDetail(rowData.ArtistProduct ,'gallery')">
              <img
                [src]="rowData.ArtistProduct.ProductImgUrl ? rowData.ArtistProduct.ProductImgUrl : 'assets/images/No-Image.png'"
                class="img-fluid" [alt]="'sharedListProducts.productImage' | transloco"
                style="width: 100%; height: auto; object-fit: contain; transition: transform 0.3s;" />
              </div>
              <div class="card-body text-center dsPortfolioLabel">
                <h5 class="text-uppercase fw-bold">
                  <a href="javascript:void(0);" class="text-dark text-decoration-none dsPortfolioDisplayLabel">
                    {{ rowData.ArtistProduct.Name }}
                  </a>
                </h5>
                <!-- <div class="d-flex justify-content-center align-items-center">
                <span class="fw-semibold">Price:</span>
                <span class="text-success ms-1">
                  {{ rowData.ArtistProduct.ArtistRevenue | currency: currencyCode : 'symbol' : '1.2-2' }}
                </span>
              </div> -->
            </div>
          }
        </div>
      </div>
    }
  </div>
}
@if (isPortfolioActive) {
  <div class="d-flex justify-content-center shadow-sm rounded p-4">
    <span>{{ 'sharedListProducts.portfolioIsInactive' | transloco }}</span>
  </div>
}
</div>
</div>

<p-dialog [showHeader]="false" [modal]="true" [(visible)]="showProductDialog" [resizable]="false" [draggable]="false"
  styleClass="dialogcontent-without-padding" [style]="{ width: '1000px' }">
  @if (showProductDialog) {
    <app-artist-selected-product-dialog [ArtistProduct]="selectedProduct" [isArtist]="isArtist" [isGallery]="isGallery"
      [GalleryProduct]="selectedGalleryProduct" [BusinessName]="BusinessName"
    (closeDialog)="closeArtistSelectedProductDialog()"></app-artist-selected-product-dialog>
  }
</p-dialog>